import * as React from "react";
import { IdentityCreateForm } from "./form";

export const IdentityCreateInitializer: React.FC = () => {
  return <IdentityCreateForm />;
};
